/*
 * @Author: Mike Cottingham 
 * @Date: 2018-04-24 19:15:52 
 * @Last Modified by: Mike Cottingham
 * @Last Modified time: 2018-05-07 11:22:21
 */

import * as actions from "./actions"
import components from "./components"
import { reducer } from "./reducer"
import * as selectors from "./selectors"
import Service from "./service"

import "./client.css"

export default {
  actions,
  components,
  reducer,
  selectors,
  Service
}